import { useNavigate, useLocation } from 'react-router-dom';
import { useDarkMode } from '../themeContext';
import React from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Container,
    Box,
    IconButton
} from '@mui/material';
import { Menu, AttachMoney } from '@mui/icons-material';
import logodef from './assets/logodef.png'

const Home = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>;
const Add = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>;
const AccountCircle = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>;
const Login = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line></svg>;
const Logout = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>;
const Search = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>;



const Navigation = ({ onMenuClick, userId }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const token = localStorage.getItem('token');
    const isLoggedIn = Boolean(token);

    // Define nav items
    const navItems = [
        { id: '/', label: 'Home', icon: <Home /> },
        { id: '/submit', label: 'Submit Data', icon: <Add /> },
        {id: '/search', label: 'Search', icon: <Search />},
        ...(isLoggedIn ? [{ id: '/account', label: 'Account', icon: <AccountCircle /> }] : []),
        isLoggedIn
            ? { id: '/logout', label: 'Log Out', icon: <Logout /> }
            : { id: '/login', label: 'Login', icon: <Login /> }
    ];

    const handleNavigation = (path) => {
        navigate(path);
    };

    // const isDark = useDarkMode();
    return (
        <AppBar position="sticky" sx={{ bgcolor: 'white', color: 'text.primary' }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        onClick={() => handleNavigation('/')}
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.1rem',
                            color: 'black',
                            textDecoration: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        RentRadar
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton size="large" onClick={onMenuClick} color="inherit">
                            <Menu />
                        </IconButton>
                    </Box>

                    <Typography
                        variant="h5"
                        noWrap
                        component="div"
                        onClick={() => handleNavigation('/')}
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.1rem',
                            color: 'inherit',
                            textDecoration: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        RentRadar
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end'}}>
                        {navItems.map((item) => (
                            <Button
                                key={item.id}
                                onClick={() => handleNavigation(item.id)}
                                startIcon={item.icon}
                                variant={location.pathname === item.id ? 'contained' : 'text'}
                                sx={{
                                    my: 2,
                                    mx: 1,
                                    color: location.pathname === item.id ? 'white' : '#dd6b20',
                                    backgroundColor: location.pathname === item.id ? '#dd6b20' : 'transparent',
                                    '&:hover': {
                                        backgroundColor: location.pathname === item.id ? '#c05621' : 'rgba(221, 107, 32, 0.1)',
                                    },
                                }}
                            >
                                {item.label}
                            </Button>
                        ))}
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navigation;
